//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import PersonalData from "../components-v2/Settings/PersonalData.vue";
import FeatureList from "../components-v2/Features/FeatureList.vue";
import sharedMethods from "../sharedMethods";

export default {
  components: {
    PersonalData,
    FeatureList,
  },
  computed: {
    ...mapGetters(["getApi", "getHost", "getApi", "getFbToken", "getHostname"]),
    isNewPwValid() {
      return this.newPassword.length >= 6;
    },
  },

  data() {
    return {
      username: "",
      vorname: "",
      nachname: "",
      email: "not set",
      slide: "style",
      profileImage: "",
      showChangePW: false,
      oldPassword: "",
      newPassword: "",
      repeatPassword: "",
      changePwButtonDisabled: true,
      api: "test",
      userMailAdress: "",
      userMailRepeat: "",
      editMailAdress: false,
      accID: this.$store.getters.getUser.AccID,
    };
  },
  async created() {
    if (!this.$store.getters.isLoggedIn && this.$router.currentRoute.path !== "/login") {
      this.$router.push("/login");
    }
    this.api = this.getApi;
    this.email = this.$store.getters.getUser.email ? this.$store.getters.getUser.email : "not set";
    this.username = this.$store.getters.getUser.username;
    this.vorname = this.$store.getters.getUser.Vorname;
    this.nachname = this.$store.getters.getUser.Nachname;
    this.accID = this.$store.getters.getUser.AccID;
    this.profileImage = this.$store.getters.getHost + "content/" + this.accID + "/thumb/profile.png";
  },
  methods: {
    ...mapActions(["changeUserPassword", "changeUserEmail", "setFBToken", "setUserSettings", "updateUserIcon"]),
    removeFBToken() {
      this.setFBToken("");
    },

    isRepeatPwValid() {
      if (this.repeatPassword == this.newPassword) this.validatePwChangeForm();

      return this.repeatPassword == this.newPassword;
    },
    validatePwChangeForm() {
      if (this.isNewPwValid) this.changePwButtonDisabled = false;
      else this.changePwButtonDisabled = true;
    },

    changePasword(oldPW, newPW, repeat) {
      const requestBody = {
        id: this.$store.getters.getUser.id,
        oldPW: oldPW,
        newPW: newPW,
      };

      if (newPW != repeat) {
        sharedMethods.warnNotify("Entered passwords are not the same");
        console.log("MDE PW VAL: " + requestBody.toString());
      } else {
        this.changeUserPassword(requestBody).then((resp) => {
          if (resp.data.status == 200) {
            this.showChangePW = !this.showChangePW;
            sharedMethods.successNotify(resp.data.msg);
          } else sharedMethods.warnNotify(resp.data);
        });
      }
    },
    chooseFiles: function() {
      document.getElementById("avatarUpload").click();
    },
    async uploadAvatar() {
      const file = this.$refs.file.files[0];
      this.file = file;

      if (file.size > 1024 * 1024 * 500) {
        console.log("MDE: FILE TOO BIG");
        sharedMethods.errorNotify("This file is too big, please use another one");
      } else {
        this.updateUserIcon(this.file).then((error) => {
          if (!error) {
            var timestamp = new Date().getTime();
            this.profileImage = this.profileImage + "?t=" + timestamp;
            var el = document.getElementById("avatarImg");

            el.src = this.profileImage + "?t=" + timestamp;
          } else {
            sharedMethods.errorNotify("error");
          }
        });
      }
    },
    logout() {
      this.$store.dispatch("logout");
      if (this.$router.currentRoute.path !== "/login") {
        this.$router.push("/login");
      }
    },
    hasFeature(featureId) {
      return sharedMethods.hasFeature(featureId);
    },
  },
};
